@import "@/styles/variables";

.iconFilter {
	cursor: pointer;
	width: 1.5rem;
	height: 1.5rem;
	display: block;
}

.filterWrapper {
	position: relative;
	display: inline-block;
}

.filter {
	min-width: 21em;
	position: absolute;
	background-color: white;
	padding: 20px;
	z-index: 1000;
	top: calc(100% + 10px);
	border-radius: 10px;
	color: $gray-500;
	right: 0;
	display: none;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	text-align: left;

	&.active {
		display: block;
	}

	h3 {
		color: $secondary-color;
		font-weight: 600;
		font-size: 18px;
		margin: 0 0 10px 0;
	}

	h4 {
		color: $gray-700;
		font-weight: 600;
		font-size: 14px;
		margin: 15px 0 10px 0;
	}
}

.divider {
	margin: 10px 0;
	border: 0;
	border-top: 1px solid $gray-200;

	&.searchMobile {
		display: none;

		@media (max-width: 750px) {
			display: block;
		}
	}
}

.searchContainer {
	display: none;

	@media (max-width: 750px) {
		display: flex;
	}

	justify-content: center;
	align-items: center;
	margin-bottom: 10px;

	input {
		width: 100%;
		padding: 9px;
		padding-left: 1em;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		border-top: 1px solid $primary-color;
		border-bottom: 1px solid $primary-color;
		border-left: 1px solid $primary-color;
		border-right: none;

		&:focus {
			outline: none !important;
			border: 1px solid $primary-hover;
			border-right: none;
		}

		&::placeholder {
			color: $primary-color;
		}
	}

	.buttonSearch {
		width: 44px;
		height: 44px;
		cursor: pointer;
		background-color: $primary-color;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		border-top: 1px solid $primary-color;
		border-bottom: 1px solid $primary-color;
		border-right: 1px solid $primary-color;
		background-image: url("../../../assets/images/desktop/buscarblanco.svg");
		background-position: center;
		background-repeat: no-repeat;
		background-size: 23px;
		flex-shrink: 0;

		&:hover {
			background-color: $secondary-color;
		}
	}
}

.currencySection {
	margin-bottom: 15px;
}

.switchContainer {
	width: 100%;
	margin-top: 8px;
}

.filterSection {
	margin-top: 15px;
}

.checkboxRow {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	gap: 10px;

	input[type="checkbox"] {
		width: 16px;
		height: 16px;
		cursor: pointer;
		flex-shrink: 0;
	}

	.label {
		flex: 1;
		font-size: 12px;
		color: $gray-700;
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
		user-select: none;

		strong {
			font-weight: 600;
		}
	}

	.arrowToggle {
		width: 1em;
		height: 1em;
		cursor: pointer;
		transition: transform 0.2s ease;
		flex-shrink: 0;

		&.rotated {
			transform: rotate(180deg);
		}
	}
}

.parentToggleLabel {
	flex: 1;
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	color: $gray-600;
}

.nestedItems {
	margin-left: 26px;
	margin-top: 4px;
	margin-bottom: 4px;
}

.applyButtonWrapper {
	margin-top: 24px;
	padding-top: 16px;
	border-top: 1px solid $gray-200;
}

.applyButton {
	margin-top: 20px;
	background-color: white;
	padding: 8px 16px;
	border-radius: 5px;
	text-align: center;
	color: $gray-700;
	border: 1px solid $gray-700;
	cursor: pointer;
	font-size: 14px;
	transition: all 0.2s ease;

	&:hover {
		background-color: #7fb02f;
		color: white;
		border-color: #7fb02f;
	}
}

.unitMeasurementSection {
	margin-top: 15px;
}
